import axios, { type AxiosResponse } from "axios";
import apiClient from "./apiBase";
import type { ContactFormSubmitPayload, IpInfoResponse } from "./form.type";

const IP_INFO_URL = "https://ipinfo.io/json";

export class ContactFormApi {
  async sendUserForm(data: ContactFormSubmitPayload): Promise<AxiosResponse<void>> {
    return apiClient.post("/api/contact-us-form", data);
  }
  async getCountry(): Promise<AxiosResponse<IpInfoResponse>> {
    return axios.get(IP_INFO_URL);
  }
}

export const contactFormApi = new ContactFormApi();
